import { locationHasWarning, locationIsInvalid, locationIsOutsideTerritory } from '@/server-data'

export function getLocationAccuracy(location: uui.domain.client.Location) {
  if (locationIsOutsideTerritory(location)) {
    return 'out-of-territory'
  }

  if (locationIsInvalid(location)) {
    return 'invalid-latLng'
  }

  if (locationHasWarning(location)) {
    return 'low-accuracy'
  }

  return 'ok'
}
